<template>
  <!--
    Placeholder rows shown while a report table loads.

    A bare centred spinner tells you nothing about what is coming and lets
    the page jump when the rows finally land. This holds the table's shape
    instead, so the layout is already settled when the data replaces it.

    Purely presentational — it renders no data and makes no requests.
    Styling lives in assets/styles/admin-theme.css (.admin-skeleton*).
  -->
  <div class="admin-table-wrap admin-skeleton" role="status" aria-live="polite">
    <span class="admin-skeleton__label">Loading…</span>
    <div v-for="n in rows" :key="n" class="admin-skeleton__row" aria-hidden="true">
      <span
        v-for="c in columns"
        :key="c"
        class="admin-skeleton__cell"
        :class="cellClass(c)"
      ></span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  // How many placeholder rows to draw. Roughly a screenful by default.
  rows: { type: Number, default: 6 },
  // How many placeholder cells per row — match the table it stands in for.
  columns: { type: Number, default: 4 },
});

// The first column is usually the row's subject and the last is usually
// short (a count, a status, an action), so vary the widths rather than
// drawing identical bars — an even grid reads as a loading grid, not as a
// table about to appear.
function cellClass(index) {
  if (index === 1) return 'admin-skeleton__cell--lg';
  if (index === props.columns) return 'admin-skeleton__cell--sm';
  return '';
}
</script>
